import { API_VERSION_REQ_ORDER } from '../../order-define';
export const reqApiVersion = (options) => {
    const { headerKey = 'isc-api-version', version = '2.0' } = options || {};
    return {
        reqOrder: API_VERSION_REQ_ORDER,
        reqInterceptor(req) {
            if (headerKey && !req.headers[headerKey])
                req.headers[headerKey] = version;
            return req;
        }
    };
};
